Ext.define('SA.VectorMapColorExpressions', {
    singleton: true,

    color(value) {
        return `#${value}`;
    },

    stepColor(attribute, {breaks, colors}) {
        var step = ['step', ['get', attribute], `#${colors[0]}`, ...breaks.flatMap((br, i) => [br, `#${colors[i + 1]}`])];

        return ['case', ['!=', ['get', attribute], null], step, ['rgba', 0, 0, 0, 0]];
    }
});